"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-locked.tsx
var Locked = function Locked(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M57 33H15C11.6863 33 9 35.6863 9 39V60C9 63.3137 11.6863 66 15 66H57C60.3137 66 63 63.3137 63 60V39C63 35.6863 60.3137 33 57 33Z",
    stroke: "#6B707E",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _preact.h)("path", {
    d: "M21 33V21C21 17.0218 22.5804 13.2064 25.3934 10.3934C28.2064 7.58035 32.0218 6 36 6C39.9782 6 43.7936 7.58035 46.6066 10.3934C49.4196 13.2064 51 17.0218 51 21V33",
    stroke: "#6B707E",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var _default = Locked;
exports.default = _default;